export default {
    transformInsurancePlans(group, valueKey, labelKey) {
        if (group.insurancePlans) {
            return group.insurancePlans.map((ip) => ({
                value: ip[valueKey],
                label: ip[labelKey],
                data: ip,
            }))
        }

        return [
            {
                value: group[valueKey],
                label: group[labelKey],
                data: group,
            },
        ]
    },

    transform(valueKey, labelKey) {
        return (data) =>
            JSON.parse(data).map((option) => ({
                heading: option.insurancePlans ? option[labelKey] : null,
                value: option[valueKey],
                label: option[labelKey],
                options: this.transformInsurancePlans(option, valueKey, labelKey),
            }))
    },
}
